export const JOB_STEPS = [
    {
        title: 'JOB_INFO_TITLE',
        value: 'info',
        draft: 'info',
    },
    {
        title: 'CANDIDATE_PROFILE_TITLE',
        value: 'profile',
        draft: 'candidate_profile',
    },
    {
        title: 'WHAT_IS_OFFERED',
        value: 'offer',
        draft: 'offer',
    },
    {
        title: 'TEAM_INFO_TITLE',
        value: 'team',
        draft: 'team_info',
    },
    {
        title: 'INTERVIEW_PROCESS',
        value: 'process',
        draft: 'interview_process',
    },
    {
        title: 'EXTENSION_FIELDS',
        value: 'extension',
        draft: 'extension_fields',
    },
    {
        title: 'FEE_SETTINGS',
        value: 'fees',
        draft: 'fee_settings',
    },
    {
        title: 'PSL',
        value: 'psl',
        draft: 'psl',
    },
]; 